function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M118.1,80.6V21.8h7.8V51l29.2-29.2h10.6L141,45.6l25.8,35h-10.3l-20.9-29.8l-9.6,9.4v20.4H118.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M201.5,66.9l7.5,0.9c-1.2,4.4-3.4,7.7-6.5,10.2s-7.2,3.6-12.2,3.6c-6.2,0-11.2-1.9-14.8-5.8 c-3.7-3.8-5.5-9.2-5.5-16.1c0-7.2,1.8-12.7,5.5-16.7s8.5-5.9,14.4-5.9c5.7,0,10.4,1.9,14,5.8s5.4,9.3,5.4,16.4c0,0.4,0,1.1,0,1.9 h-31.8c0.3,4.7,1.6,8.3,4,10.8s5.3,3.7,8.9,3.7c2.6,0,4.9-0.7,6.8-2.1S200.4,70,201.5,66.9z M177.8,55.2h23.8 c-0.3-3.6-1.2-6.3-2.7-8.1c-2.3-2.8-5.3-4.2-8.9-4.2c-3.3,0-6.1,1.1-8.4,3.3C179.3,48.5,178,51.5,177.8,55.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M217.9,80.6V21.8h7.2v58.8H217.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M248.1,80.6L231.9,38h7.6l9.1,25.5c1,2.8,1.9,5.6,2.7,8.6c0.6-2.2,1.5-4.9,2.7-8.1l9.5-26h7.4l-16.1,42.6 H248.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M277.4,30.1v-8.3h7.2v8.3C284.6,30.1,277.4,30.1,277.4,30.1z M277.4,80.6V38h7.2v42.6H277.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M295.6,80.6V38h6.5v6.1c3.1-4.7,7.6-7,13.6-7c2.6,0,4.9,0.5,7.1,1.4s3.8,2.1,4.8,3.6c1.1,1.5,1.8,3.3,2.2,5.3 c0.3,1.3,0.4,3.7,0.4,7v26.2H323V54.7c0-2.9-0.3-5.1-0.8-6.6c-0.6-1.5-1.6-2.6-3-3.5s-3.1-1.3-5-1.3c-3.1,0-5.7,1-8,2.9 c-2.2,2-3.3,5.7-3.3,11.1v23.3C302.9,80.6,295.6,80.6,295.6,80.6z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M86,4.2H26.3c-3.2,0-5.8,2.6-5.8,5.8v73.4c0,3.2,2.6,5.8,5.8,5.8h59.9c3.2,0,5.8-2.6,5.8-5.8V10 C91.9,6.8,89.3,4.2,86,4.2z M64.1,77.1L54.1,49l-6,10v18.1h-7.3V17.2h7.3v26.6l14.7-26.6h9.9L59.2,40.6l14.4,36.5H64.1z"
});

var SvgKelvinIcon = function SvgKelvinIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 349.9 93",
    style: {
      enableBackground: "new 0 0 349.9 93"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgKelvinIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kelvin-icon.2bdbc594.svg";
export { ForwardRef as ReactComponent };